import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Layout } from '../../../models/loyalty-layout.model';
import { LoyaltyLayoutService } from '../../../services/loyalty/layout.service';
import { Router } from '@angular/router';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-loyalty-layout',
  templateUrl: './loyalty-layout.component.html',
  styleUrls: ['./loyalty-layout.component.css']
})
export class LoyaltyLayoutComponent implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  layouts: Array<Layout>;
  showModalDelete: boolean;
  serverPagination = KontableComponent.ServerPagination;
  newDataAvailable = false;
  listStates: Array<{value: string, label: string}> = [{ label: '', value: null }];
  selectFilter = KontableComponent.SelectFilter;

  constructor(
    private translate: TranslateService,
    public layoutService: LoyaltyLayoutService,
    private router: Router
  ) { }

  ngOnInit() {
    this.translate.get([
      'layout.description',
      'layout_detail.layout_id',
      'layout_detail.row_position',
      'layout_detail.row_description',
      'layout_detail.row_max_lenght',
      'layout_detail.start_offset',
      'common.status_notDeleted',
      'common.status_onlyDeleted'
    ]).subscribe((translations) => {
      this.columsTitles = {
        description: translations['layout.description'],
        layout_id: translations['layout_detail.layout_id'],
        row_position: translations['layout_detail.row_position'],
        row_description: translations['layout_detail.row_description'],
        row_max_lenght: translations['layout_detail.row_max_lenght'],
        start_offset: translations['layout_detail.start_offset']
      };
      this.listStates.push({ label: translations['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: translations['common.status_onlyDeleted'], value: '1' });
    });
  }

  reloadList() {
      this.newDataAvailable = true;
  }

  addNew(event: any) {
    this.router.navigate(['/loyalty/layout/form/']);
  }

  edit(layout: Layout) {
    this.router.navigate(['/loyalty/layout/form/' + layout.id]);
  }

  recover(layout) {
    this.layoutService.recover(layout).subscribe((res ) => {
      this.newDataAvailable = true;
    });
  }

  remove(layout: Layout) {
    this.layoutService.remove(layout.id).subscribe((res ) => {
      this.reloadList ();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-layout/loyalty-layout.component.ts